import { Module } from "vuex";
import { IFDGState } from "@/core/interfaces/state/fdgState.interface";
import { StoreState } from "@/store/type";

import mutations from "./mutations";
import actions from "./actions";
import state from "./state";
import getters from "./getters";

const fdgModule: Module<IFDGState, StoreState> = {
  state,
  mutations,
  actions,
  getters,
};

export default fdgModule;
